"use client";

import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { selectIsAuthSuccessOrPerpetual, useAppSelector } from "@repo/global-store";
import { ReactNode } from "react";

const AmcHideOnLogin = ({ children }: { children: ReactNode }) => {
  const isLoggedIn = useAppSelector(selectIsAuthSuccessOrPerpetual);
  return !isLoggedIn && !isOpenInApp() ? <>{children}</> : null;
};

export default AmcHideOnLogin;
